<!-- @format -->

<template>
  <div id="participant-print-card" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-row>
            <el-col :span="24">
              <div class="registration-question">
                <div class="sub-title">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.cardDesign") }}</div>
                <el-select v-model="form.schemeID" :class="$inputError('schemeID', validationErrors)">
                  <el-option v-for="item in printSchemeList" :key="item.id" :value="item.id" :label="item.title"></el-option>
                </el-select>
                <span class="text-danger">{{ $errorMessage("schemeID", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="registration-question">
                <div class="sub-title">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.description") }}</div>
                <el-input type="textarea" rows="2" resize="none" v-model="form.reason"></el-input>
              </div>
            </el-col>
            <el-col :span="24" class="mt-2">
              <el-button-group>
                <el-button round size="mini" type="default" @click="addBaseReason($t('participantManagament.registrationSearch.detailsParticipant.printCardComp.lostCard'))">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.lostCard") }}</el-button>
                <el-button round size="mini" type="default" @click="addBaseReason($t('participantManagament.registrationSearch.detailsParticipant.printCardComp.printerError'))">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.printerError") }}</el-button>
                <el-button round size="mini" type="default" @click="addBaseReason($t('participantManagament.registrationSearch.detailsParticipant.printCardComp.problemTag'))">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.problemTag") }}</el-button>
                <el-button round size="mini" type="default" @click="addBaseReason($t('participantManagament.registrationSearch.detailsParticipant.printCardComp.incorrectRegistration'))">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.incorrectRegistration") }}</el-button>
                <el-button round size="mini" type="default" @click="addBaseReason($t('participantManagament.registrationSearch.detailsParticipant.printCardComp.informationUpdate'))">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.informationUpdate") }}</el-button>
              </el-button-group>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save(false)" :loading="loading == 'printCard'">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.print") }}</el-button>
        <el-button type="primary" @click="save(true)" :loading="loading == 'printCardCheckIn'">{{ $t("participantManagament.registrationSearch.detailsParticipant.printCardComp.checkAndPrint") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["participantId"],
  data() {
    return {
      loading: false,
      timeout: null,
      validationErrors: [],
      form: {
        id: null,
        schemeID: null,
        reason: null,
        checkIn: true
      },
      printHtml: null
    };
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    printSchemeList() {
      return this.$store.state.printschemes.items.map(x => {
        return { id: x.id, title: x.title };
      });
    }
  },
  methods: {
    addBaseReason(text) {
      this.form.reason = text;
    },
    async save(checkIn = false) {
      if (!checkIn) {
        this.loading = "printCard";
      } else {
        this.loading = "printCardCheckIn";
      }
      this.form.id = this.participantId;
      this.form.checkIn = checkIn;
      var res = await this.$store.dispatch("participantPrintCard", this.form);
      this.validationErrors = res.data.validationErrors;
      if (!res.data.alert.hasError) {
        this.printHtml = res.data.data.printHTML;
        this.$store.commit("setPrintSchemeId", this.form.schemeID);
        this.$emit("refresh");
        this.$emit("closeDialog");
      }
      this.loading = false;
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    var fIndex = this.printSchemeList.findIndex(x => x.id == this.$store.state.participants.selectedPrintSchemeID);
    if (fIndex != -1) {
      this.form.schemeID = this.$store.state.participants.selectedPrintSchemeID;
    } else {
      this.$store.state.participants.selectedPrintSchemeID = null;
    }
    await this.$store.dispatch("getPrintSchemes");
    this.loading = false;
  }
};
</script>

<style lang="less" scoped>
.registration-question {
  width: 100%;
  transition: 1s;
  margin-top: 18px;

  .sub-title {
    color: #292f3b;
    font-weight: 400;
    margin-bottom: 8px;
    font-size: 14px;
  }

  span {
    color: #505763;
    font-size: 13px;
    font-weight: 400;
  }

  .choice-questions {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-date-editor {
    width: 100% !important;
  }

  .rate-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 150px;

    .el-slider {
      width: 100%;
    }
  }
}
</style>
<style lang="less">
#participant-print-card {
  .modal-body {
    .el-button--mini.el-button--mini.is-round {
      padding: 6px 10px !important;
      font-size: 11px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/PrintCard.vue